export enum EnvironmentNames {
    enterprise = 'Ent',
    dev = 'Dev',
    local = 'Local',
    test = 'Test',
    prod = 'Prod',
    staging = 'Staging',
    releaseCandidate = 'RC'
}
